import { isSvgTrace } from "./appVariant";

import svgTraceLogo1 from "../assets/logo1.svg";
import svgTraceLogoIcon from "../assets/svgtrace.svg";
import embroideryTraceIcon from "../assets/embroiderytrace_icon.png";
import embroideryTraceIconDark from "../assets/embroiderytrace_icon_dark.png";
import embroideryTraceNeedle from "../assets/embroiderytrace_needle.png";

const svgTraceBranding = {
  appName: "SvgTrace",
  proName: "SvgTrace Pro",
  logo: svgTraceLogo1,
  logoDark: svgTraceLogo1,
  logoIcon: svgTraceLogoIcon,
  tagline: "Convert images to scalable vectors",
  pageTitle: "SvgTrace",
  themeColor: "#f453c4",
};

const embroideryTraceBranding = {
  appName: "EmbroideryTrace",
  proName: "EmbroideryTrace",
  logo: embroideryTraceIcon,
  logoDark: embroideryTraceIconDark,
  logoIcon: embroideryTraceNeedle,
  tagline: "Convert images to embroidery files",
  pageTitle: "EmbroideryTrace",
  themeColor: "#f453c4",
};

const branding = isSvgTrace ? svgTraceBranding : embroideryTraceBranding;

export default branding;
